<template>
  <div class="rights">

    <div class="rights-table">
      <div>
        服务名称
      </div>
      <div>
        PD-1
        （已使用/总次数）
      </div>
      <div>
        看诊方式
      </div>
      <div>
        看诊时间
      </div>
      <div>
        看诊专家
      </div>
      <template v-for="(column, index) in rightsList">
        <div :key="index">
          {{ column.expert_service_name }}
        </div>
        <div :key="index">
          {{ column.pd1_compare }}
        </div>
        <div :key="index">
          {{ column.expert_type_name }}
        </div>
        <div :key="index">
          {{ column.expert_time }}
        </div>
        <div :key="index">
          {{ column.expert_name }}
        </div>
      </template>
    </div>
  </div>
</template>
  
  <script>
import pd1Service from "@/apis/pd1/index.js";
import enums from "@/views/pd1/mixins/enums";

export default {
  data() {
    return {
      rightsList: [],
    };
  },
  mixins: [enums],

  created() {
    this.getQuanyiDetail();
  },
  methods: {
    getQuanyiDetail() {
      const params = {
        work_id: this.$route.query.work_id,
      };
      pd1Service.quanyiDetail(params).then((res) => {
        this.rightsList = res;
      });
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.rights {
  padding: 0 20px;
  overflow-y: scroll;
  height: 100%;
}
.rights-item {
  margin: 20px 0;
  background-color: black;
  box-sizing: border-box;
  border: 1px solid black;
  overflow: hidden;
}
.rights-table {
  display: grid;
  grid-template-columns: 50% 25% 25% 25% 25%;
  text-align: center;
  grid-row-gap: 1px;
  grid-column-gap: 1px;

  div {
    background-color: #fff;
    padding: 5px 10px;
  }
}
</style>